import React from "react";
import Modal from "react-modal";
import "./style.css";
import CloseOutline from "react-ionicons/lib/CloseOutline";
import useDesktopSize from "../../utils/hooks/useDesktopSize";

interface IProps {
  open: boolean;
  afterOpenModal?: () => void;
  closeModal: () => void;
  styles?: any;
  children: any;
  title: string;
  acceptText?: string;
  cancelText?: string;
  onAccept: () => void;
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-40%, -50%)",
    backgroundColor: "var(--dark-background)",
    borderRadius: "12px",
    width: "60%",
  },
};

const customStylesMobile = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "var(--dark-background)",
    borderRadius: "12px",
    width: "80%",
  },
};

const ModalComponent: React.FC<IProps> = ({
  open,
  afterOpenModal = () => {},
  closeModal,
  styles,
  children,
  title,
  acceptText = "Akceptuj",
  cancelText = "Anuluj",
  onAccept,
}: IProps) => {
  const isDesktop = useDesktopSize();
  return (
    <Modal
      isOpen={open}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={styles ? styles : isDesktop ? customStyles : customStylesMobile}
      contentLabel="modal"
    >
      <div className={`modal-header ${!isDesktop && "modal-header-mobile"}`}>
        <h3>{title}</h3>
        <button onClick={closeModal}>
          <CloseOutline color={"#00000"} title={""} height="30px" width="30px" />
        </button>
      </div>
      <div className={"modal-children"}>{children}</div>
      <div className={"modal-footer"}>
        <button className={"primary-button"} onClick={onAccept}>
          {acceptText}
        </button>
        <button className={"secondary-button"} onClick={closeModal}>
          {cancelText}
        </button>
      </div>
    </Modal>
  );
};
Modal.setAppElement("#root");

export default ModalComponent;
